import algoliasearch from 'algoliasearch/lite';
import { varsFromServer } from '../client_side_injection_vars';
// Uses a secured algolia key that can only access Geogrouping_* or Building_* records with is_published:true
let client;
export default () => {
  if (client) {
    return client;
  }
  client = algoliasearch(varsFromServer.algoliaAppId, varsFromServer.algoliaApiKey);
  return client;
};
